"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationHistoryTranscriptCommonModelOutputRole = void 0;
exports.ConversationHistoryTranscriptCommonModelOutputRole = {
    User: "user",
    Agent: "agent",
};
